import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Global, css } from "@emotion/react";

import IndexRoute from "./routes/IndexRoute";
import { Box, ThemeProvider } from "@mui/material";
import theme, { globalStyles } from "../assets/styles/theme";

export function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Global styles={globalStyles} />
        <React.Fragment>
          <Box className="main-container">
            <BrowserRouter>
              <IndexRoute />
            </BrowserRouter>
          </Box>
        </React.Fragment>
      </ThemeProvider>
    </>
  );
}

export default App;
